import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListContactsContactRequest extends IBaseRequest {
    type?:         string;
    specificType?: string;
    content?:      string;
    isPrimary?:    string;
    isMain?:       string;
    noSystemUser?: string;
    limit?:        number;
    offset?:       number;
}

export class ListContactsContactRequest extends BaseRequest implements IListContactsContactRequest {

    public type?:         string;
    public specificType?: string;
    public content?:      string;
    public isPrimary?:    string;
    public isMain?:       string;
    public noSystemUser?: string;
    public limit?:        number;
    public offset?:       number;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.type = otherOptions.type;
        this.specificType = otherOptions.specificType;
        this.content = otherOptions.content;
        this.isPrimary = otherOptions.isPrimary;
        this.isMain = otherOptions.isMain;
        this.noSystemUser = otherOptions.noSystemUser;
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.type, 'type');
        parameters += this.makeNode(this.specificType, 'specificType');
        parameters += this.makeNode(this.content, 'content');
        parameters += this.makeNode(this.isPrimary, 'isPrimary');
        parameters += this.makeNode(this.isMain, 'isMain');
        parameters += this.makeNode(this.noSystemUser, 'noSystemUser');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        
        return super.wrapperXml('ListContactsContact', parameters);
    }
}
